import {
  ref, watch, computed, getCurrentInstance,
} from '@vue/composition-api';
import axios from 'axios'
import store from '@/store';
import { showToast, useRouter } from '@/@core/utils/utils';
// import JSZip from 'jszip'
// import { saveAs } from 'file-saver';

export default function useView(context) {
  const { route } = useRouter();

  const loading = ref(true)
  const total = ref(0)
  const itemsData = ref([]);
  const dataRelate = ref([])
  const dataRelateNews = ref([])
  const attached_files = ref([])
  const content_files = ref([])
  const tags = ref([])
  const author = ref({})
  const coAuthor = ref([])
  const dataApproved = ref({})
  const dataCorrected = ref({})
  const all_file = ref([])
  const disabledDowloadAll = ref(false)
  const donate_title = ref('Bài viết hay? Hãy tặng sao cho tác giả')
  const article_id = ref('')
  const documentMimetypes = ['txt', 'doc', 'docx', 'pdf', 'ppt', 'pptx'];
  const donate = ref({
    donate_type: '',
    total: 0,
    liked: 0,
    heart: 0,
    star: 0,
    clap: 0,
  })
  const donate_message = {
    liked: 'Bạn đã tặng sao "Bổ ích" cho tác giả',
    clap: 'Bạn đã tặng sao "Cảm hứng" cho tác giả',
    star: 'Bạn đã tặng sao "Độc đáo" cho tác giả',
    heart: 'Bạn đã tặng sao "Cảm xúc" cho tác giả',
  }
  const popoverShow = ref(false)

  const Imgsize = computed({
    get() {
      return store.state.home.bannerMinHeight
    },
    set(val) {
      store.dispatch('home/setHeight', val)
    },
  });
  const plusDonate = (type) => {
    if (type === 'liked') { donate.value.liked += 1 } else if (type == 'star') { donate.value.star += 1 } else if (type == 'clap') { donate.value.clap += 1 } else if (type === 'heart') { donate.value.heart += 1 }
    donate.value.total += 1;
  }
  const minusDonate = (type) => {
    if (type === 'liked' && donate.value.liked > 0) { donate.value.liked -= 1 } else if (type === 'star' && donate.value.star > 0) { donate.value.star -= 1 } else if (type === 'clap' && donate.value.clap > 0) { donate.value.clap -= 1 } else if (type === 'heart' && donate.value.heart) { donate.value.heart -= 1 }
  }
  const messageDonate = (type) => {
    let donate_title = 'Bài viết hay? Hãy tặng sao cho tác giả'
    if (type) {
      donate_title = donate_message[type];
    }
    return donate_title;
  }
  const handlDonate = (type) => {
    const { donate_type } = donate.value
    if (donate_type) {
      if (donate_type === type) {
        minusDonate(type)
        if (donate.value.total > 0) {
          donate.value.total -= 1
        }
        donate.value.donate_type = ''
      } else {
        minusDonate(donate_type)
        if (donate.value.total > 0) {
          donate.value.total -= 1
        }
        plusDonate(type)
        donate.value.donate_type = type;
      }
    } else {
      donate.value.donate_type = type;
      plusDonate(type)
    }

    store.dispatch('home/donate', {
      id: article_id.value,
      type,
    }).then(response => {
      const result = response.data;
      if (result.code === 200) {
        //  console.log('data', result.data)
        // donate.value = result.data;
      }
    })
    popoverShow.value = false
  }

  const handlePopover = () => {
    popoverShow.value = !popoverShow.value
  }
  const downloadItem = (zip, item) =>
  // console.log('item', item)
    axios.get(item.file_path, { responseType: 'blob' }).then((resp) => {
      zip.file(item.name, resp.data);
    })

  const downloadAll = (itemData) => {
    disabledDowloadAll.value = true;
    // const timeStamp = Date.now()
    const fileDownloadAll = [...attached_files.value, ...content_files.value];
    // //  CHỉ download file media
    // const fileDownloadAll = [...content_files.value];

    // const zip = new JSZip();
    // const endpoints = fileDownloadAll.map((item) => (item.file_path ? item.file_path : item));
    // const nameFromURL = fileDownloadAll.map((item) => {
    //   // const urlArr = item.file_path ? item.file_path.split('/') : item.split('/');
    //   // return urlArr[urlArr.length - 1];
    //   let fileName = 'no_name';
    //   if (item.file_path === undefined) {
    //     const urlArr = item.split('/');
    //     fileName = urlArr[urlArr.length - 1];
    //   } else {
    //     fileName = item.filename_original ? item.filename_original : item.name + item.extension
    //   }
    //   return fileName
    // });

    // // const files = zip.folder('files');
    // let count = 0;
    // Promise.all(endpoints.map((endpoint) => axios.get(endpoint, { responseType: 'blob' }))).then((response) => {
    //   // console.log('reponse.data', response)
    //   if (response) {
    //     response.forEach((value, index) => {
    //       // console.log(value.data)
    //       // files.file(nameFromURL[index], value.data, { binary: true });
    //       zip.file(nameFromURL[index], value.data, { binary: true });
    //       count += 1;
    //       if (count === endpoints.length) {
    //         zip.generateAsync({ type: 'blob' }).then((blob) => {
    //           saveAs(blob, `folder_${timeStamp}.zip`);
    //           // itemData.disabled = false;
    //           disabledDowloadAll.value = false;
    //         });
    //       }
    //     })
    //   }
    // })
    //   .catch(err => {
    //     showToast(`Không tải file được: ${err}`)
    //   });
    fileDownloadAll.forEach((value, index) => {
      dowload(value)
    });
    disabledDowloadAll.value = false;
  }
  const convertHTMLEntity = (text) => {
    const span = document.createElement('span');

    return text
      .replace(/&[#A-Za-z0-9]+;/gi, (entity, position, text) => {
        span.innerHTML = entity;
        return span.innerText;
      });
  }
  const doCopy = () => {
    let content = itemsData.value.content.replace(/(<([^>]+)>)/ig, '');
    content = content.replace(/^\s*$(?:\r\n?|\n)/gm, '');
    content = convertHTMLEntity(content);
    console.log('content', content);
    context.root.$copyText(content).then(() => {
      showToast('Copy nội dung thành công', { variant: 'success' })
    }, e => {
      showToast('Không thể copy nội dung')
    })
    return content
  }

  const timeago = (published_at) => {
    const time = Math.floor(Date.now() / 1000) - published_at;
    if (time < 1) {
      return 'vừa xong';
    }
    const a = [
      { number: 31536000, name: 'năm' },
      { number: 2592000, name: 'tháng' },
      { number: 86400, name: 'ngày' },
      { number: 3600, name: 'giờ' },
      { number: 60, name: 'phút' },
      { number: 1, name: 'giây' },
    ]
    for (let i = 0; i < a.length; i++) {
      const d = time / a[i].number
      if (d >= 1) {
        const r = Math.round(d);
        return `${r} ${a[i].name}`
      }
    }
  }

  const iconView = (content_type) => {
    const dataType = JSON.parse(content_type);
    const data = [];
    dataType.forEach(element => {
      if (element == 'news') {
        data.push('<span class="iconNews"></span>')
      } else if (element == 'video') {
        data.push('<span class="iconVideo"></span>')
      } else if (element == 'audio') {
        data.push('<span class="iconAudio"></span>')
      } else if (element == 'photo') {
        data.push('<span class="iconImage"></span>')
      }
      return data;
    });
  }

  const dowload = async (file) => {
    if (!itemsData.value.is_read) {
      return;
    }
    let name = '';
    if (file.file_path === undefined) {
      const urlArr = file.split('/');
      // console.log(urlArr);
      name = urlArr[urlArr.length - 1];
    } else {
      name = file.filename_original ? file.filename_original : `${file.name}.${file.extension}`
    }
    // const name = `${file.name}.${file.extension}`;
    const url = file.full_path ? file.full_path : file;
    const data = await fetch(url)
    const blob = await data.blob()
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.setAttribute('href', objectUrl)
    link.setAttribute('download', name)
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const renderAuthor = (data, author) =>
  //  lọc cả các tác giả trùng với trong co_author
  // return 1;
  // const item = data.filter(t => t.user_id !== author.user_id);
  // return item.map(o => o.alias).join(';');
  // const item = data.filter(t => t.user_id !== author.user_id);

  // return Array.isArray(data) ? [...new Set(data.map(o => o.alias))].join(';') : '---';

  // return [...new Set(data.map(o => o.alias))].join(';');
    [...new Set(data.map(o => `${o.alias}`))].join('; ')
  // return [...new Set(data.map(o => `${o.alias} (${o.username}) - ${o.unit ?? o.unit_code}`))].join(';');
  // BD: Lãnh đạo phòng (hoaldphong) - V1, Phóng Viên (phongvien1) - V2

  const renderPartOrUnit = (listArray, str) => {
    if (listArray.includes(str)) {
      return listArray.join(',')
    }
    listArray.push(str);
    return listArray.join(',')
  }

  const renderFileNameMedia = (file) => {
    let fileName = '';
    if (file.file_path === undefined && typeof file === 'string') {
      const urlArr = file.split('/');
      fileName = urlArr[urlArr.length - 1];
    } else {
      fileName = file.filename_original ? file.filename_original : `${file.name}.${file.extension}`
    }
    return fileName;
  }

  const export2Word = (element, filename = '') => {
    const css = (
      '<style>'
        + '.image { width: 100% !important}'
        + 'img {max-width: 50% !important; width: 50% !important; object-fit: contain !important; }table {border-collapse: collapse; border-spacing: 0;}td{padding: 6px;}'

        + '@font-face {font-family:"Times New Roman"; panose-1:2 4 5 3 5 4 6 3 2 4;mso-font-charset:0;mso-generic-font-family:"Times New Roman";mso-font-pitch:variable; mso-font-signature:-536869121 1107305727 33554432 0 415 0;}'
        + '@font-face {font-family:Times New Roman;panose-1:0 0 0 0 0 0 0 0 0 0;mso-font-alt:"Times New Roman";mso-font-charset:0;mso-generic-font-family:roman;mso-font-format:other;mso-font-pitch:auto;mso-font-signature:0 0 0 0 0 0;}'
        + 'p.MsoNormal, li.MsoNormal, div.MsoNormal{mso-style-unhide:no;mso-style-qformat:yes;mso-style-parent:"";margin:0in;margin-bottom:.0001pt;mso-pagination:widow-orphan;font-size:12.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman"mso-fareast-theme-font:minor-fareast;}'
        + 'a:link, span.MsoHyperlink{mso-style-noshow:yes;mso-style-priority:99;color:blue;text-decoration:underline;text-underline:single;}'
        + 'a:visited, span.MsoHyperlinkFollowed{mso-style-noshow:yes;mso-style-priority:99;color:purple;text-decoration:underline;text-underline:single;}'
        + 'p{mso-style-noshow:yes;mso-style-priority:99;mso-margin-top-alt:auto; margin-right:0in;mso-margin-bottom-alt:auto;margin-left:0in;mso-pagination:widow-orphan;font-size:12.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";mso-fareast-theme-font:minor-fareast;}'
        + 'p.msonormal0, li.msonormal0, div.msonormal0{mso-style-name:msonormal;mso-style-unhide:no;mso-margin-top-alt:auto;margin-right:0in;mso-margin-bottom-alt:auto;margin-left:0in;mso-pagination:widow-orphan;font-size:12.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";mso-fareast-theme-font:minor-fareast;}'
        // + 'p.image, li.image, div.image{mso-style-name:image;mso-style-noshow:yes;mso-style-priority:99;mso-style-unhide:no;mso-margin-top-alt:auto;margin-right:0in;mso-margin-bottom-alt:automargin-left:0in;mso-pagination:widow-orphan;font-size:12.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";mso-fareast-theme-font:minor-fareast;}'
        + 'p.mb-0, li.mb-0, div.mb-0{mso-style-name:mb-0;mso-style-unhide:no;mso-margin-top-alt:auto;margin-right:0in;mso-margin-bottom-alt:auto;margin-left:0in;mso-pagination:widow-orphan;font-size:12.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";mso-fareast-theme-font:minor-fareast;}'
        + 'p.text-align-right, li.text-align-right, div.text-align-right {mso-style-name:text-align-right; mso-style-unhide:no;      mso-margin-top-alt:auto;margin-right:0in;mso-margin-bottom-alt:auto;margin-left:0in;mso-pagination:widow-orphan;font-size:12.0pt;      font-family:"Times New Roman",serif; mso-fareast-font-family:"Times New Roman";mso-fareast-theme-font:minor-fareast;}'
        + 'span.SpellE{mso-style-name:""; mso-spl-e:yes;}'
        + '.MsoChpDefault{mso-style-type:export-only; mso-default-props:yes;font-size:10.0pt;mso-ansi-font-size:10.0pt;mso-bidi-font-size:10.0pt;}'
        + '@page WordSection1 {size:8.5in 11.0in; margin:1.0in 1.0in 1.0in 1.0in; mso-header-margin:.5in;  mso-footer-margin:.5in; mso-paper-source:0;}'
        + 'div.WordSection1 {page:WordSection1;}'
        + 'table.MsoNormalTable{mso-style-name:"Table Normal";mso-tstyle-rowband-size:0;mso-tstyle-colband-size:0;mso-style-noshow:yes;mso-style-priority:99;mso-style-parent:"";mso-padding-alt:0in 5.4pt 0in 5.4pt;mso-para-margin:0in;mso-para-margin-bottom:.0001pt;mso-pagination:widow-orphan;font-size:10.0pt;font-family:"Times New Roman",serif;}'
        + '</style>'
    );
      // console.log(!2321213);
      // const preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    const preHtml1 = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>";
    const head = '<head>\n<meta http-equiv="Content-Type" content="text/html; charset=utf-8">_styles_</head>\n';
    const preHtml = `${preHtml1 + head}<body>`;

    const postHtml = '</body></html>';
    // console.log(document.getElementById('#articleContent'))
    // const content = document.getElementById('articleContent').innerHTML.replaceAll('!important', '').replaceAll('image', '');

    document.getElementById('articleContent').querySelectorAll('.image').forEach(el => {
      el.style.width = '100%'
    });
    document.getElementById('articleContent').querySelectorAll('img').forEach(el => {
      el.setAttribute('width', 576)
      // el.setAttribute('height', 432)
    });

    const content = document.getElementById('articleContent').innerHTML;
    // console.log('content', content)

    let html = preHtml + content + postHtml;
    html = html.replace('_styles_', css);

    const blob = new Blob(['\ufeff', html], {
      type: 'application/msword',
    });

    // Specify link url
    const url = `data:application/vnd.ms-word;charset=utf-8,${encodeURIComponent(html)}`;

    // Specify file name
    filename = element ? `${element.title}.doc` : 'document.doc';

    // Create download link element
    const downloadLink = document.createElement('a');

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = url;

      // Setting the file name
      downloadLink.download = filename;

      // triggering the function
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
    document.getElementById('articleContent').querySelectorAll('img').forEach(el => {
      el.removeAttribute('width')
      el.removeAttribute('height')
    });
  }

  const doBookmark = (id) => {
    store.dispatch('home/bookmark', id).then(response => {
      const result = response.data;
      if (result.code === 200) {
        //  console.log(result.data)
        itemsData.value.is_bookmark = result.data;
        // itemsData.value.is_read = true;
        // if (itemsData.value.unit) {
        //   // itemsData.value.unit = `${itemsData.value.unit},${result.data.unit}`
        //   itemsData.value.unit = renderPartOrUnit(itemsData.value.unit.split(','), result.data.unit);
        // } else {
        //   // itemsData.value.unit = result.data.unit;
        //   itemsData.value.unit = renderPartOrUnit([], result.data.unit);
        // }
        // if (itemsData.value.depart_read) {
        //   itemsData.value.depart_read = renderPartOrUnit(itemsData.value.depart_read.split(','), result.data.department_code);
        //   // itemsData.value.depart_read = `${itemsData.value.depart_read},${result.data.department_code}`;
        // } else {
        //   itemsData.value.depart_read = renderPartOrUnit([], result.data.department_code);
        //   // itemsData.value.depart_read = result.data.department_code
        // }
        // loadHtml(itemsData.value.content)
        showToast(result.message, { variant: 'success' })
      } else {
        showToast(result.message)
      }
    })
  }

  const renderClassTitleView = (item) => {
    // 1. Tin bình thường mầu đen
    // 2. Tin đã click màu ghi
    // 3. Tin hot màu đỏ tười có iconhot
    // 4. TIn đã lấy màu nâu đỏ có icon xanh
    // 5. Tin hot đã click màu ghi có icon hot
    // 6. TIn hot đã lấy màu nâu đỏ có icon xanh, icon hot
    let classTitle = 'class_title_detail_normall';
    if (item.hot) {
      if (item.is_get) { // đã lấy thì đã đọc
        if (item.is_view) {
          classTitle = 'class_title_detail_hot_get_view'
        } else {
          classTitle = 'class_title_detail_hot_get_notview'
        }
      } else if (!item.is_get) { // tin chưa lấy những có thể đọc hoặc chưa đọc
        if (item.is_view) {
          classTitle = 'class_title_detail_hot_notget_view'
        } else {
          classTitle = 'class_title_detail_hot_notget_notview' // tin hot chưa lấy chưa đọc
        }
      }
    } else if (!item.hot) {
      if (item.is_get) { // tin đã lấy thì đã đọc
        if (item.is_view) {
          classTitle = 'class_title_detail_nothot_get_view'
        } else {
          classTitle = 'class_title_detail_nothot_notget_notview'
        }
      } else if (!item.is_get) {
        if (item.is_view) { // tin bt nhưng đã xem chưa lấy
          classTitle = 'class_title_detail_nohot_notget_view'
        } else {
          classTitle = 'class_title_detail_nohot_notget_notview'
        }
      }
    }

    return classTitle;
  }

  const checkMineType = (file) => {
    try {
      const url = file.file_path ? file.file_path : file
      const extension = url.split('.').pop()
      return documentMimetypes.value.includes(extension);
    } catch (error) {
      return false;
    }
  }

  const makeSlug = (str, replacer) => {
    // remove accents
    const from = 'àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ';
    const to = 'aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy';
    for (let i = 0, l = from.length; i < l; i++) {
      str = str.replace(RegExp(from[i], 'gi'), to[i]);
    }
    if (replacer) {
      str = str.toLowerCase()
        .trim()
        .replace(/[^a-z0-9\-]/g, replacer)
        .replace(/-+/g, replacer);
    }
    return str;
  }

  const loadHtml = (content) => {
    if (itemsData.value.is_read) {
      content = content.replace(/(\r\n|\n|\r|\t)/gm, '');
      content = content.trim();
      // console.log('loadHtml', content);
      const dom = new DOMParser().parseFromString(content, 'text/html');
      // console.log('dom', dom);
      const allItems = dom.querySelectorAll('img, audio, video');
      // console.log('allItems', allItems);
      allItems.forEach((item) => {
        let name = '';
        // console.log(item, 'nextSibling');
        // console.log(item.nextSibling, item.nextSibling.nextElementSibling.innerHTML);
        if (item.closest('figure')) {
          if (item.closest('figure').querySelector('figcaption')) {
            name = item.closest('figure').querySelector('figcaption').textContent;
          }
        } else if (item.nextSibling && item.nextSibling.nextElementSibling) {
          name = item.nextSibling.nextElementSibling.textContent;
        }
        if (name && name.length > 200) {
          name = name.substring(0, 200)
        }
        // console.log('name', name)
        let file = item.src ? item.src : '';
        if (file === '') {
          const source = item.querySelector('source');
          file = source ? source.src : file
        }
        // console.log('file', file)
        let ext = 'jpg';
        if (file) {
          ext = file.substr(file.lastIndexOf('.') + 1) || ext;
        }
        // console.log('ext', ext)
        let newFile = '';

        if (ext && name) {
          newFile = `${name}.${ext}`;
        } else {
          newFile = file.split('/').pop().toLowerCase();
        }
        const downloadElement = `<span class="vovat-media-download d-block"><a href="javascript:;" class="btn btn-blue taive" onClick="downloadFile(this)" dataname="${newFile}" dataurl="${file}"><span class="icon_taive"></span></a></span>`;
        if (item.closest('p')) {
          item.closest('p').insertAdjacentHTML('beforeend', downloadElement);
        } else if (item.closest('figure')) {
          item.closest('figure').insertAdjacentHTML('beforeend', downloadElement);
        } else {
          item.insertAdjacentHTML('beforeend', downloadElement);
        }
      });
      // console.log('dom to html', dom.body.innerHTML);
      itemsData.value.content = dom.body.innerHTML;
      // console.log('allFileInContent', allFileInContent.value);
    }
  }
  const fetchData = (id) => {
    loading.value = true;
    store.dispatch('home/show', id)
      .then(response => {
        loading.value = false;
        const result = response.data;
        if (result.code === 200) {
          context.emit('on-view-article', id)
          document.title = `${result.data.title} | CỔNG TIN TỨC ĐÀI TIẾNG NÓI VIỆT NAM`
          itemsData.value = result.data;
          article_id.value = result.data.id
          // dataRelate.value = result.data.relate
          // dataRelateNews.value = result.data.relate_data_news
          attached_files.value = result.data.attached_files
          content_files.value = result.data.files
          tags.value = result.data.tags
          author.value = result.data.author
          coAuthor.value = result.data.co_author
          dataApproved.value = result.data.dataApproved
          dataCorrected.value = result.data.dataCorrected
          donate.value = result.data.donate
          loadHtml(itemsData.value.content)
        }
      })
  }
  const fechDataRelated = (articleId) => {
    store.dispatch('home/fechDataRelated', articleId).then(response => {
      const result = response.data; console.log(result)
      if (result.code === 200) {
        dataRelate.value = result.data.relate_data
        dataRelateNews.value = result.data.relate_data_category
      }
    })
  }

  const onReadArticle = (id) => {
    store.dispatch('home/read', id).then(response => {
      const result = response.data;
      if (result.code === 200) {
        itemsData.value.is_read = true;
        context.emit('on-read-article', id)
        if (itemsData.value.unit) {
          itemsData.value.unit = renderPartOrUnit(itemsData.value.unit.split(','), result.data.unit);
        } else {
          itemsData.value.unit = renderPartOrUnit([], result.data.unit);
        }
        if (itemsData.value.depart_read) {
          itemsData.value.depart_read = renderPartOrUnit(itemsData.value.depart_read.split(','), result.data.department_code);
        } else {
          itemsData.value.depart_read = renderPartOrUnit([], result.data.department_code);
        }
        itemsData.value.count_get_article = result.data.count_get_article
        loadHtml(itemsData.value.content)
        showToast(result.message, { variant: 'success' })
      } else {
        showToast(result.message)
      }
    })
  }

  const onWindowScroll = () => {
    window.addEventListener('scroll', () => {
      if (window.scrollY <= 20) {
        if (document.querySelector('#headerBanerCategory')) {
          document.querySelector('#headerBanerCategory').classList.remove('fixBanner');
        }
        if (document.querySelector('#headerBaner')) {
          document.querySelector('#headerBaner').classList.remove('fixBanner');
        }

        // console.log('curr-0', curr)
      } else if (window.scrollY > 20) {
        if (document.querySelector('#headerBanerCategory')) {
          Imgsize.value = 50
          document.querySelector('#headerBanerCategory').classList.add('fixBanner');
        }
        if (document.querySelector('#headerBaner')) {
          Imgsize.value = 50
          document.querySelector('#headerBaner').classList.add('fixBanner');
        }
      }
    });
  }

  return {
    loadHtml,
    fetchData,
    fechDataRelated,
    itemsData,
    loading,
    total,
    dataRelate,
    attached_files,
    tags,
    author,
    coAuthor,
    dataCorrected,
    dataApproved,
    content_files,
    all_file,
    Imgsize,
    disabledDowloadAll,
    dataRelateNews,
    donate,
    donate_title,
    donate_message,
    article_id,
    documentMimetypes,
    checkMineType,
    makeSlug,
    renderClassTitleView,
    renderPartOrUnit,
    renderFileNameMedia,
    export2Word,
    doBookmark,
    plusDonate,
    minusDonate,
    messageDonate,
    onReadArticle,
    onWindowScroll,
    handlePopover,
    handlDonate,
    renderAuthor,
    dowload,
    downloadItem,
    downloadAll,
    timeago,
    iconView,
    doCopy,
    popoverShow,
  };
}
